module.exports = __webpack_public_path__ + "img/tovabbi_palyazat.6e04d086.svg";